import { useState } from "react";
import ModalVideo from "react-modal-video";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const counterData = [
  { count: 10, label: "Partner business", unit: "k+" },
  { count: 100, label: "Customers", unit: "k+" },
  { count: 1, label: "Success books and orders", unit: "million" },
  { count: 3, label: "countries", unit: "+" },
];

const MarketingPlatformSection = () => {
  const [isOpen, setOpen] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "-100px 0px",
  });

  return (
    <div className="relative overflow-hidden bg-dry py-20 px-4 min-h-screen">
      <div className="max-w-screen-xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12">
          <div className="w-full lg:w-1/2">
            <h2 className="text-3xl sm:text-5xl font-bold text-text mb-6 text-center lg:text-left">
              The #1 Integrated Solution for Businesses
            </h2>
            <p className="text-textGray text-sm max-w-md text-center lg:text-left">
              One platform. One software. AI-powered. Trusted by retail,
              restaurant, and beauty salon businesses.
            </p>
          </div>

          <div className="w-full lg:w-1/2 grid grid-cols-2 sm:grid-cols-2 gap-x-12 gap-y-8">
            {counterData.map((item, index) => (
              <div key={index} className="text-center">
                <div ref={ref} className="text-3xl font-semibold text-text">
                  <CountUp
                    end={inView ? item.count : 0}
                    duration={2.5}
                    separator=","
                  />
                  {item.unit}
                </div>
                <p className="text-textGray text-sm mt-2">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Video Preview Block */}
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId="180KJQryGwc?si=mk8azLVhFnCwPwvH"
          onClose={() => setOpen(false)}
        />

        <div className="mt-16 relative max-w-4xl mx-auto rounded-[20px] overflow-hidden">
          <div className="w-full aspect-video">
            <img
              src="/images/media/imagelokalai.png"
              alt="video thumbnail"
              className="w-full h-full object-cover"
            />
          </div>
          <button
            onClick={() => setOpen(true)}
            className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/50 transition"
          >
            <div className="bg-border w-12 h-12 rounded-full flex items-center justify-center">
              <img
                src="/images/icon/icon_140.svg"
                alt="Play video"
                className="w-6 h-6"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketingPlatformSection;
